(function (global){
'use strict';
/*jshint camelcase: false */

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
require('sticky-kit');
//require('vt-carousel');

$(document).ready(function() {

  $('body.residence .tabs').stick_in_parent({
    sticky_class: 'fixed',
    bottoming: false
  });

});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9BcHBCdW5kbGUvUmVzb3VyY2VzL3NjcmlwdHMvdGVtcGxhdGVzL2Jvb2tpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsImZpbGUiOiJnZW5lcmF0ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlc0NvbnRlbnQiOlsiJ3VzZSBzdHJpY3QnO1xuLypqc2hpbnQgY2FtZWxjYXNlOiBmYWxzZSAqL1xuXG52YXIgJCA9ICh0eXBlb2Ygd2luZG93ICE9PSBcInVuZGVmaW5lZFwiID8gd2luZG93WydqUXVlcnknXSA6IHR5cGVvZiBnbG9iYWwgIT09IFwidW5kZWZpbmVkXCIgPyBnbG9iYWxbJ2pRdWVyeSddIDogbnVsbCk7XG5yZXF1aXJlKCdzdGlja3kta2l0Jyk7XG4vL3JlcXVpcmUoJ3Z0LWNhcm91c2VsJyk7XG5cbiQoZG9jdW1lbnQpLnJlYWR5KGZ1bmN0aW9uKCkge1xuXG4gICQoJ2JvZHkucmVzaWRlbmNlIC50YWJzJykuc3RpY2tfaW5fcGFyZW50KHtcbiAgICBzdGlja3lfY2xhc3M6ICdmaXhlZCcsXG4gICAgYm90dG9taW5nOiBmYWxzZVxuICB9KTtcblxufSk7Il19